export class AppraisalProductCriteriaApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCriteria() {
    return this.#http.get('/api/appraisal-product-criteria-collection');
  }

  async createCriteria(body) {
    return this.#http.put('/api/appraisal-product-criteria-collection', { create: [body] });
  }

  async editCriteria(body) {
    return this.#http.put('/api/appraisal-product-criteria-collection', { update: body });
  }

  async deleteCriteria({ criteriaId }) {
    return this.#http.put('/api/appraisal-product-criteria-collection', { remove: [criteriaId] });
  }
}
